var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHypodermics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48623 21.8287C5.71526 22.0577 6.08593 22.0577 6.31495 21.8287C6.5439 21.5997 6.5439 21.2291 6.31495 21L5.90061 20.5858L8.15567 18.3306L5.66979 15.8447L3.41469 18.0998L3.00043 17.6855C2.7714 17.4564 2.40074 17.4564 2.17171 17.6855C1.94276 17.9145 1.94276 18.2851 2.17171 18.5141L5.48623 21.8287Z",
    fill: "#FE7E07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0274 9.62948L17.2704 10.8725C17.3805 10.7624 17.4684 10.6136 17.4684 10.4581V9.38674L14.6129 6.57031H13.5415C13.3861 6.57031 13.2372 6.63184 13.1272 6.74192L8.15527 11.7011L12.2985 15.8445L13.1272 15.0157L11.8843 13.7728C11.6552 13.5438 11.6552 13.1731 11.8843 12.9441C12.1133 12.7151 12.4839 12.7151 12.7129 12.9441L13.9559 14.1871L14.7845 13.3585L13.5415 12.1155C13.3126 11.8865 13.3126 11.5158 13.5415 11.2868C13.7706 11.0578 14.1412 11.0578 14.3703 11.2868L15.6132 12.5298L16.4419 11.7011L15.1989 10.4581C14.9699 10.2292 14.9699 9.8585 15.1989 9.62948C15.4279 9.40045 15.7984 9.40045 16.0274 9.62948V9.62948Z",
    fill: "#FE7E07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8282 2.17177C21.5992 1.94274 21.2285 1.94274 20.9995 2.17177L18.0229 5.14836C17.3701 4.83879 16.5671 4.94695 16.0276 5.48641L15.6133 5.90075L18.0992 8.38663L18.5136 7.97237C19.053 7.43291 19.1612 6.6299 18.8516 5.97708L21.8282 3.00045C22.0572 2.77146 22.0572 2.40079 21.8282 2.17177V2.17177Z",
    fill: "#FE7E07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4706 16.6725L7.32738 12.5293L6.91304 12.9436C6.68444 13.1722 6.31299 13.1722 6.08439 12.9436C5.85537 12.7145 5.48478 12.7145 5.25575 12.9436C5.02673 13.1726 5.02673 13.5433 5.25575 13.7722L10.2276 18.7441C10.4566 18.9731 10.8273 18.9731 11.0563 18.7441C11.2853 18.5151 11.2853 18.1444 11.0563 17.9155C10.8276 17.6868 10.8276 17.3154 11.0563 17.0868L11.4706 16.6725Z",
    fill: "#FE7E07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypodermics);
export default __webpack_public_path__ + "static/media/hypodermics.40112cca6d359a5131039b5cd657cede.svg";
export { ForwardRef as ReactComponent };